"use strict";

module.exports = function () {
  return Math.ceil(this.count / this.limit);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/total-pages.js
// module id = 447
// module chunks = 64